import { useUserRoles } from 'src/Hooks/user'
import { canViewInstallationDeviceStatus } from '../utils/can-view-installation-device-status'
import { isFlowTheme } from 'src/Libs/utils/theme-helpers'
import { InstallationStatus } from '../types'

export const useCanViewInstallationDeviceStatus = (installationStatus?: InstallationStatus): { canViewInstallationDeviceStatus: boolean } => {
  const { isUser } = useUserRoles()

  return { canViewInstallationDeviceStatus: canViewInstallationDeviceStatus(isUser, !isFlowTheme, installationStatus) }
}
